// import axios from "axios";
import strategyActionTypes from "../types/strategyActionTypes ";
import chargingStrategiesService from "./../../services/chargingStrategies.service";

export const getStrategies = () => async (dispatch) => {
    try {
        var response = await chargingStrategiesService.getChargingStrattegies();
        dispatch({
            type: strategyActionTypes.GET_STRATEGY_SUCCESS,
            payload: response.data?.payload,
        });
    } catch (error) {
        dispatch({
            type: strategyActionTypes.GET_STRATEGY_FAILURE,
            payload: error
        });
    }

};

export const updateStrategy = (strategy) => async (dispatch) => {
    try {
        dispatch({
            type: strategyActionTypes.START_UPDATE_STRATEGY,
        });
        var response = await chargingStrategiesService.updateChargingStrategy(strategy);
        dispatch({
            type: strategyActionTypes.UPDATE_STRATEGY_SUCCESS,
            payload: response.data,
        });
    } catch (error) {

        dispatch({
            type: strategyActionTypes.UPDATE_STRATEGY_FAILURE,
            payload: error.response,
        });

    }
};

export const addStrategy = (strategy) => async (dispatch) => {
    try {
        dispatch({
            type: strategyActionTypes.START_ADD_STRATEGY,
        });
        var response = await chargingStrategiesService.addChargingStrategy(strategy);
        
        //var response = await chargingStrategiesService.getChargingStrattegies;

        dispatch({
            type: strategyActionTypes.ADD_STRATEGY_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: strategyActionTypes.ADD_STRATEGY_FAILURE,
            payload: error.response,
        });
    }
};

export const deleteStrategy = (id) => async (dispatch) => {
    try {
        dispatch({
            type: strategyActionTypes.START_DELETE_STRATEGY,
        });
        var response = await chargingStrategiesService.deleteChargingStrategy(id);
        dispatch({
            type: strategyActionTypes.DELETE_STRATEGY_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: strategyActionTypes.DELETE_STRATEGY_FAILURE,
            payload: error.response,
        });

    }
};

export const setSelectedStrategy = selectedStrategy => (dispatch) => {
    localStorage.setItem('selectedStrategy', JSON.stringify(selectedStrategy));
    dispatch({ type: strategyActionTypes.SELECT_STRATEGY, payload: selectedStrategy });
};

export const resetStateInfo = () => (dispatch) => {
    dispatch({
        type: strategyActionTypes.RESET_STATE_INFO
    });
};

export const getChargePointChargingStrategy = (data) => async (dispatch) => {
    let response;
    try {
        dispatch({
            type: strategyActionTypes.START_GET_CHARGE_POINT_STRATEGY,
        });
        response = await chargingStrategiesService.getChargePointChargingStrategy(data);

        dispatch({
            type: strategyActionTypes.GET_CHARGE_POINT_STRATEGY_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: strategyActionTypes.GET_CHARGE_POINT_STRATEGY_FAILURE,
        });
    }

    return response;
};

export const getChargePointChargingStrategyByTransaction = (data) => async (dispatch) => {
    let response;
    try {
        dispatch({
            type: strategyActionTypes.START_GET_CHARGE_POINT_STRATEGY,
        });
        response = await chargingStrategiesService.getChargePointChargingStrategyByTransaction(data);

        dispatch({
            type: strategyActionTypes.GET_CHARGE_POINT_STRATEGY_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: strategyActionTypes.GET_CHARGE_POINT_STRATEGY_FAILURE,
        });
    }

    return response;
};

const strategyActions = {
    getStrategies,
    addStrategy,
    updateStrategy,
    deleteStrategy,
    setSelectedStrategy,
    resetStateInfo,
    getChargePointChargingStrategy,
    getChargePointChargingStrategyByTransaction
}
export default strategyActions;







